import { EntityGridList } from "@/modules/common/components";
import { Pagination } from "@/modules/common/types/Pagination";
import { LeadListItemResponse } from "@/service/response/admin-leads";

import LeadListHeader, { LEADS_LIST_MIN_WIDTH } from "./LeadListHeader";
import LeadListLine from "./LeadListLine";
import LeadListSkeleton from "./LeadListSkeleton";

interface LeadsListProps {
  data?: Pagination<LeadListItemResponse>;
  isLoading?: boolean;
  isFetching?: boolean;
  limit?: number;
  onChangePage: (nextPage: number) => void;
  onChangePageSize: (nextSize: number) => void;
}

const LeadsList = (props: LeadsListProps) => (
  <EntityGridList
    {...props}
    minWidthClassName={LEADS_LIST_MIN_WIDTH}
    renderHeader={() => <LeadListHeader />}
    renderRow={(lead) => <LeadListLine lead={lead} />}
    renderSkeleton={(limit) => <LeadListSkeleton limit={limit} />}
  />
);

export default LeadsList;
